import { useMemo } from 'react';

const useRandomizedId = (idPrefix: string): string => {
  const randomizedId = useMemo(
    // eslint-disable-next-line react-hooks/purity
    () => `${idPrefix}-${Math.random()}`,
    [idPrefix],
  );

  return randomizedId;
};

export default useRandomizedId;
